export const mutations = {
    setProduto(state, produto){
        state.produto = produto
    },
    setProdutos(state, produtos){
        state.produtos = produtos
    },
    setModalCadastroProduto(state, status){
        state.modalCadastroProduto = status
    },
    setModalExcluirProduto(state, status){
        state.modalExcluirProduto = status
    },
    setModalClonarProduto(state, status){
        state.modalClonarProduto = status
    },
    setFotoProduto(state, foto){
        state.foto = foto
    },
    setModalTransferenciaEstoqueProduto(state, status){
        state.modalTransferenciaEstoqueProduto = status
    }
    
}

export default {}